/* eslint-disable react/jsx-wrap-multilines */
import React, { useState } from 'react';
import { Link } from 'react-router';
import { useAccount, useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Feedback } from 'Feedback/index';
import { AppBar, Button, colors, Popover, Typography } from '@equinor/opt-ui-core';
import { AccountCircle } from '@equinor/opt-ui-icons';
import { Icons, Title, UserContainer } from './styles';
// Component
const AppHeader = () => {
    const { accounts, instance } = useMsal();
    const account = useAccount(accounts[0] || {});
    const isAuthenticated = useIsAuthenticated();
    const shortName = account && account.username ? account.username.split('@')[0] : null;
    const [open, setOpen] = useState(false);
    // handlers
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (React.createElement(AppBar, { className: "app-header", zIndex: 0, borderBottomWidth: 1, header: React.createElement(Link, { to: "/" },
            React.createElement(Title, null, "OMNIA.prevent")), actions: React.createElement(Icons, null, isAuthenticated ? (React.createElement(React.Fragment, null,
            React.createElement(UserContainer, null,
                React.createElement(Feedback, null),
                React.createElement(Popover, { open: open, backgroundColor: colors.secondary, showClose: true, onOpen: handleOpen, onClose: handleClose, title: "User Info", content: React.createElement(Typography, { variant: "body_short" }, account.username), footer: [
                        React.createElement(Button, { key: "header_popover_logout", onClick: () => instance.logoutRedirect() }, "Log Out"),
                        React.createElement(Button, { key: "header_popover_close", variant: "outlined", color: "primary", onClick: handleClose }, "Cancel")
                    ], trigger: ['hover', 'click'] },
                    React.createElement("span", { style: {
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap'
                        } },
                        shortName ? React.createElement("span", { className: "app-text-p-r" }, shortName) : null,
                        React.createElement(AccountCircle, { size: 16 })))))) : (React.createElement(Button, { variant: "outlined", color: "primary", onClick: () => instance.loginRedirect() }, "Log In"))) }));
};
export default AppHeader;
